import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import mapValues from 'lodash/mapValues';
import * as yup from 'yup';

var getGenericError = ({
  key,
  message,
  id,
  section
}) => ({
  [key]: {
    id: "genericError" /* GENERIC_ERROR */,
    data: {
      message
    },
    kind: {
      id,
      data: {
        message
      },
      type: "genericError" /* GENERIC_ERROR */,
      section
    }
  }
});
var getTaxesId = (key, field, tableKey) => {
  const taxesTableFields = /* @__PURE__ */ new Set(["to", "from", "tax", "repeat"]);
  if (taxesTableFields.has(field)) {
    return `taxes-${key}-table-${tableKey}-${field}`;
  }
  return `taxes-${key}-${field}`;
};
var getTaxesError = (key, field, tableKey) => {
  const objectKey = getTaxesId(key, field, tableKey);
  return getGenericError({
    key: objectKey,
    id: field,
    message: i18n_config_default.t(`settingsModule.taxesSettings.errors.${field}`),
    section: "taxes" /* TAXES */
  });
};
var taxesSchema = yup.lazy((obj) => {
  return yup.object(
    mapValues(
      obj,
      (_, key) => yup.object().shape({
        name: yup.string().trim().required(JSON.stringify(getTaxesError(Number(key), "name"))),
        orderTypes: yup.string().required(JSON.stringify(getTaxesError(Number(key), "orderTypes"))),
        typeData: yup.object({
          interval: yup.number().moreThan(0, getTaxesError(Number(key), "interval")).nullable(),
          rate: yup.number().moreThan(0, getTaxesError(Number(key), "rate")).nullable()
        }).nullable(),
        tableTypeData: yup.lazy((row) => {
          return yup.object(
            mapValues(row, (__, rowKey) => {
              return yup.object({
                from: yup.number(),
                to: yup.number().moreThan(
                  yup.ref("from"),
                  getTaxesError(Number(key), "to", Number(rowKey))
                )
              });
            })
          ).nullable();
        })
      })
    )
  );
});

export { getTaxesId, taxesSchema };
